import React, { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useOutletContext } from 'react-router-dom';
import SPASectionHeading from '../../shared/SPASectionHeading';
import { useSPAToast } from '../../shared/SPAToast';
import { PanelFooter, panelClass } from '../../shared/formPanel';
import { settingsPayload, toFormValues } from './programForm';
import type { ProgramFormValues } from './programForm';
import ProgramSettingsFields from './ProgramSettingsFields';
import { EditableProgram, useUpdateProgram } from './useProgram';

const ProgramSettingsPanel = () => {
  const program = useOutletContext<EditableProgram>();
  const spaToast = useSPAToast();
  const updateProgram = useUpdateProgram(program.id);
  const values = useMemo(() => toFormValues(program), [program]);
  const form = useForm<ProgramFormValues>({ values });

  const save = (formValues: ProgramFormValues) => {
    updateProgram.mutate(settingsPayload(formValues, program.custom), {
      onSuccess: () => spaToast.success('Saved program settings.'),
    });
  };

  return (
    <form noValidate className={panelClass} onSubmit={form.handleSubmit(save)}>
      <SPASectionHeading className="tw-mb-5" title="Program Settings" />
      <ProgramSettingsFields custom={program.custom} form={form} />
      <PanelFooter update={updateProgram} />
    </form>
  );
};

export default ProgramSettingsPanel;
